import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-event-month-card__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventMonthCard = _resolveComponent("EventMonthCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
      return (_openBlock(), _createBlock(_component_EventMonthCard, {
        key: index,
        event: event,
        onClick: ($event: any) => (_ctx.$emit("openEvent", event))
      }, null, 8, ["event", "onClick"]))
    }), 128))
  ]))
}